// src/components/ServicioAlClienteContent.jsx
import React from 'react';
import './ServicioAlClienteContent.css';

const ServicioAlClienteContent = () => {
  const contactInfo = {
    phone: '55 1500 4000',
    email: 'pedidos@packsys.com',
    pressOption: '1',
    hours: 'Lunes a Viernes: 7:00 AM - 8:00 PM',
    emergency: 'Sábados: 8:00 AM - 4:00 PM',
    whatsapp:
      'https://api.whatsapp.com/send?phone=525515004000&text=Hola%2C+me+gustaría+recibir+información+sobre+sus+servicios+y+cotizaciones.',
  };

  const services = [
    {
      icon: '📦',
      title: 'Seguimiento de Pedidos',
      description:
        'Rastrea tu pedido en tiempo real y recibe actualizaciones instantáneas',
      features: [
        'Estado actual del envío',
        'Tiempo estimado de entrega',
        'Historial de movimientos',
      ],
      details: 'Para más detalles, consulta el siguiente link:',
      link_details: 'https://packsys.com/',
      link_meaning: 'Página de Packsys',
    },
    {
      icon: '🔄',
      title: 'Devoluciones y Cambios',
      description: 'Proceso sencillo para devoluciones y cambios de productos',
      features: [
        'Política de 30 días',
        'Cambio sin costo',
        'Reembolsos rápidos',
      ],
      details: 'Para más detalles, consulta el siguiente link:',
      link_details: 'https://packsys.com/policies/refund-policy',
      link_meaning: 'Política de Reembolsos',
    },
    {
      icon: '💳',
      title: 'Soporte de Facturación',
      description: 'Ayuda con facturas, pagos y estados de cuenta',
      features: ['Facturación electrónica', 'Estado de cuenta', 'Aclaraciones'],
      details: 'Para facturar tu compra, consulta el siguiente link:',
      link_details: 'https://packsys.com/pages/factura-tu-compra',
      link_meaning: 'Página de Información de Facturación',
    },
    /*
    {
      icon: '🚚',
      title: 'Soporte Logístico',
      description: 'Asistencia con envíos, rutas y programaciones',
      features: [
        'Programación de entregas',
        'Optimización de rutas',
        'Seguimiento avanzado',
      ],
    },*/
  ];

  const faqs = [
    {
      question: '¿Cómo puedo rastrear mi pedido?',
      answer:
        'Puedes rastrear tu pedido ingresando el número de seguimiento en nuestra página principal de tracking o llamando a nuestro centro de servicio al cliente.',
    },
    {
      question: '¿Cuál es el tiempo de entrega estimado?',
      answer:
        'El tiempo de entrega varía según la ubicación y tipo de servicio. Generalmente es de 2-5 días hábiles dentro de la República Mexicana.',
    },
    {
      question: '¿Puedo cambiar la dirección de entrega?',
      answer:
        'Sí, puedes solicitar el cambio de dirección llamando a nuestro centro de servicio antes de que el pedido salga para entrega.',
    },
    {
      question: '¿Qué hago si mi pedido llega dañado?',
      answer:
        'Contacta inmediatamente a nuestro servicio al cliente. Tomaremos fotos del empaque y producto, y gestionaremos el reemplazo inmediato.',
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <section
        className="mt-24 pt-32 pb-20 px-4 relative bg-cover bg-center bg-no-repeat bg-packsys-blue bg-blend-multiply"
        style={{
          backgroundImage: 'url(/tracking_servicio_cliente.png)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-800/20 to-blue-500/30"></div>
        {/* Overlay para mejor legibilidad del texto */}
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-4xl md:text-6xl font-black text-white mb-6 animate-fade-in-up drop-shadow-lg">
            Servicio al <span className="text-packsys-orange">Cliente</span>
          </h1>
          <p className="text-xl text-white mb-8 max-w-3xl mx-auto leading-relaxed animate-fade-in-up animation-delay-300 drop-shadow-md">
            Estamos aquí para ayudarte. En Packsys, tu satisfacción es nuestra
            prioridad. Contáctanos para cualquier duda, consulta o asistencia
            que necesites.
          </p>
        </div>
      </section>

      {/* El resto del código permanece igual */}
      {/* Contact Information */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Contact Cards */}
            <div className="space-y-6 animate-slide-up">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">
                Contáctanos
              </h2>

              {/* Phone Card */}
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-6 text-white shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                    <span className="text-2xl">📞</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Llámanos</h3>
                    <p className="text-blue-100">
                      Disponible durante horario de oficina
                    </p>
                  </div>
                </div>
                <div className="bg-white/10 rounded-xl p-4">
                  <p className="text-2xl font-black mb-2">
                    {contactInfo.phone}
                  </p>
                  <p className="text-blue-100">
                    Presiona{' '}
                    <span className="bg-white/20 px-2 py-1 rounded font-bold">
                      {contactInfo.pressOption}
                    </span>{' '}
                    para Servicio al Cliente
                  </p>
                </div>
                <p className="text-blue-100 text-sm mt-3">
                  {contactInfo.hours}
                </p>
                <p className="text-blue-100 text-sm">{contactInfo.emergency}</p>
              </div>

              {/* WhatsApp Card */}
              <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                    <span className="text-2xl">💬</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">WhatsApp</h3>
                    <p className="text-green-100">Respuesta inmediata</p>
                  </div>
                </div>
                <div className="bg-white/10 rounded-xl p-4">
                  <p className="text-lg font-bold mb-3">Chatea con nosotros</p>
                  <a
                    href={contactInfo.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-white text-green-600 px-6 py-3 rounded-xl font-bold hover:bg-green-50 transition-all duration-300 transform hover:scale-105"
                  >
                    <span className="mr-2">💬</span>
                    Abrir WhatsApp
                  </a>
                </div>
                <p className="text-green-100 text-sm mt-3">
                  Atención personalizada para cotizaciones y consultas
                </p>
              </div>

              {/* Email Card */}
              <div className="bg-gradient-to-r from-orange-500 to-packsys-orange rounded-2xl p-6 text-white shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                    <span className="text-2xl">✉️</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Escríbenos</h3>
                    <p className="text-orange-100">
                      Respuesta en menos de 24 horas
                    </p>
                  </div>
                </div>
                <div className="bg-white/10 rounded-xl p-4">
                  <p className="text-xl font-black break-all">
                    {contactInfo.email}
                  </p>
                </div>
                <p className="text-orange-100 text-sm mt-3">
                  Para dudas sobre pedidos, facturación y más.
                </p>
              </div>
            </div>

            {/* Services Overview */}
            <div className="animate-slide-up animation-delay-300">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">
                Nuestros Servicios
              </h2>
              <div className="grid grid-cols-1 gap-6">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 rounded-2xl p-6 hover:shadow-lg transition-all duration-500 border border-gray-200 transform hover:-translate-y-1 animate-fade-in-up"
                    style={{ animationDelay: `${index * 100 + 500}ms` }}
                  >
                    <div className="flex items-start mb-4">
                      <div className="text-3xl mr-4 transform transition-all duration-300 hover:scale-110">
                        {service.icon}
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">
                          {service.title}
                        </h3>
                        <p className="text-gray-600 mb-3">
                          {service.description}
                        </p>
                        <ul className="space-y-1">
                          {service.features.map((feature, featureIndex) => (
                            <li
                              key={featureIndex}
                              className="flex items-center text-sm text-gray-500"
                            >
                              <span className="w-2 h-2 bg-packsys-orange rounded-full mr-2"></span>
                              {feature}
                            </li>
                          ))}
                        </ul>
                        <h4 className="text-md text-gray-600 mt-4">
                          {service.details}
                        </h4>
                        <a
                          className="text-cyan-700 font-bold"
                          href={service.link_details}
                        >
                          {service.link_meaning}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12 animate-fade-in-up">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 animate-fade-in-up"
                style={{ animationDelay: `${index * 100 + 300}ms` }}
              >
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <span className="w-6 h-6 bg-packsys-orange text-white rounded-full flex items-center justify-center text-sm mr-3">
                    ?
                  </span>
                  {faq.question}
                </h3>
                <p className="text-gray-600 leading-relaxed pl-9">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency Contact */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-2xl p-8 text-white shadow-2xl hover:shadow-3xl transition-all duration-500 transform hover:scale-105 animate-pulse-slow">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-3xl">⚠️</span>
            </div>
            <h2 className="text-3xl font-bold mb-4">¿Problemas Urgentes?</h2>
            <p className="text-xl mb-6 text-red-100">
              Para situaciones que requieren atención inmediata con tu pedido o
              entrega
            </p>
            <div className="bg-white/10 rounded-xl p-4 inline-block transform hover:scale-105 transition-all duration-300">
              <p className="text-2xl font-black">{contactInfo.phone}</p>
              <p className="text-red-100">Opción rápida para emergencias</p>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Resources */}
      {/*
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12 animate-fade-in-up">
            Recursos Adicionales
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: '📚',
                color: 'blue',
                title: 'Centro de Ayuda',
                description:
                  'Guías detalladas y tutoriales para el uso de nuestros servicios',
              },
              {
                icon: '📋',
                color: 'green',
                title: 'Políticas',
                description:
                  'Conoce nuestras políticas de envío, devolución y garantía',
              },
              {
                icon: '🛠️',
                color: 'purple',
                title: 'Soporte Técnico',
                description:
                  'Asistencia especializada para problemas técnicos y configuración',
              },
            ].map((resource, index) => (
              <div
                key={index}
                className="text-center bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 animate-fade-in-up"
                style={{ animationDelay: `${index * 150 + 600}ms` }}
              >
                <div
                  className={`w-16 h-16 bg-${resource.color}-500 rounded-full flex items-center justify-center mx-auto mb-4 transform transition-all duration-300 hover:scale-110`}
                >
                  <span className="text-2xl text-white">{resource.icon}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {resource.title}
                </h3>
                <p className="text-gray-600">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}
    </>
  );
};

export default ServicioAlClienteContent;
